import useApi from "../../use/useApi";
import {useSelector} from "react-redux";
import isNull from "../../mixin/isNull";
import axios from "axios";
import ScreenShot from "../../entity/visio-plus/ScreenShot";

const SERVICE = "service-visio-plus";
const ENTITY = "screen_shots";

export default function () {
    const {findAllBy} = useApi();
    const state = useSelector;
    const newInstance = data => new ScreenShot(data);

    return {
        findAllByDiagnosticId(id) {
            return {
                select() {
                    const result = state(state => state.api?.visio_plus?.[ENTITY]?.filter(sc => !isNull(sc) && sc?.getDiagnosticId() == id));

                    if (isNull(result)) return null;

                    return result;
                },
                exec() {
                    findAllBy(SERVICE, ENTITY, "diagnostic_id", id, newInstance, "application_native");
                }
            }
        },
        getFile: async screenShotId => {
            try {
                const response = await axios.get(process.env.REACT_APP_API_URL + `/service-visio-plus/application_native/screen_shots/${screenShotId}/file`);

                return response.data;
            } catch (e) {
                console.log(e.message);
                return [];
            }
        }
    }
}